import { render, staticRenderFns } from "./VComment.vue?vue&type=template&id=7020c691&scoped=true&"
import script from "./VComment.vue?vue&type=script&lang=js&"
export * from "./VComment.vue?vue&type=script&lang=js&"
import style0 from "./VComment.vue?vue&type=style&index=0&id=7020c691&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7020c691",
  null
  
)

export default component.exports